import { ListColumn, ListDataColumn } from "../ListColumn";
import { MeddraListView } from "./MeddraListView";

export class HLTListView extends MeddraListView{

    constructor(items: any) {
        let itemsWithChecked = items;
        if (itemsWithChecked && itemsWithChecked.length>0) {
            itemsWithChecked = items.map((info: any) => ({checked: false, ...info}));
        }

        const itemFinderArrayColumns: ListColumn[] = [
            new ListColumn("Num", ListDataColumn.TEXT, "num"),
            new ListColumn("HLT Name", ListDataColumn.TEXT, "name"),
            new ListColumn("HLT Code", ListDataColumn.TEXT, "code")
        ];
        const itemFinderTreeColumns: ListColumn[] = [
            new ListColumn("HLT Name", ListDataColumn.TEXT, "name"),
            new ListColumn("HLT Code", ListDataColumn.TEXT, "code")
        ];

        super(itemsWithChecked,  itemFinderArrayColumns, itemFinderTreeColumns);        
    }

}